import CpfField from './CpfField'
import CnpjField from './CnpjField'
import IsbnField from './IsbnField'
import CodigoTabelaField from './CodigoTabelaField'
import CodigoFluxogramaField from './CodigoFluxogramaField'
import CodigoFiguraField from './CodigoFiguraField'
import CodigoCapituloField from './CodigoCapituloField'
import EdicaoField from './EdicaoField'
import CopyrightField from './CopyrightField'
import CodigoArtigoField from './CodigoArtigoField'
import ISSNField from './ISSNField'
import DateField from './DateField'

export {
  CpfField,
  CnpjField,
  IsbnField,
  CodigoTabelaField,
  CodigoFluxogramaField,
  CodigoFiguraField,
  CodigoCapituloField,
  EdicaoField,
  CopyrightField,
  CodigoArtigoField,
  ISSNField,
  DateField
}



// WEBPACK FOOTER //
// ./src/components/Fields/index.js